var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Theme1ProfileLayout',[_c('Theme1DesktopProfilesMyProfile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }